export const hexToRgb = (hex: string = '#666666'): string => {
    if (!hex) return '102, 102, 102';
    let h = hex.replace(/^#/, '');
    if (h.length === 3) h = h.split('').map(c => c + c).join('');
    const r = parseInt(h.substring(0, 2), 16);
    const g = parseInt(h.substring(2, 4), 16);
    const b = parseInt(h.substring(4, 6), 16);
    return `${r}, ${g}, ${b}`;
};

const hexTriple = (hex: string): [number, number, number] => {
    const v = parseInt(hex.slice(1), 16);
    return [(v >> 16) & 255, (v >> 8) & 255, v & 255];
};

const componentToHex = (c: number): string => {
    const h = c.toString(16);
    return h.length === 1 ? '0' + h : h;
};

export const interpolateColor = (
    factor: number,
    startColor: string = '#e54343',
    middleColor: string = '#ebc42c',
    endColor: string = '#2bb941'
): string => {
    let startRgb: number[];
    let endRgb: number[];
    let f = factor;
    if (f < 0.5) {
        startRgb = hexTriple(startColor);
        endRgb = hexTriple(middleColor);
        f *= 2;
    } else {
        startRgb = hexTriple(middleColor);
        endRgb = hexTriple(endColor);
        f = (f - 0.5) * 2;
    }
    const [r, g, b] = startRgb.map((s, i) => Math.round(s + f * (endRgb[i] - s)));
    return `#${componentToHex(r)}${componentToHex(g)}${componentToHex(b)}`;
};

export const getSugarColor = (_level: string, type?: string): string =>
    type === 'brown' ? '#c7875a' : '#edeeee';

export const getMilkColor = (type: string): string => {
    switch (type) {
        case 'no-milk': return '#d1d5db';
        case 'plant': return '#d5f1df';
        case 'cow': return '#f8fafc';
        case 'coconut': return '#fef3c7';
        case 'almond': return '#fde68a';
        case 'oat': return '#d4a373';
        case 'evaporated': return '#fef9c3';
        default: return '#f8fafc';
    }
};
